module.exports = __webpack_public_path__ + "img/Group 4041.e85d3558.png";